import { motion } from "framer-motion";

function LangPill({ lang }) {
  const isKr = lang === "ht";
  return (
    <span
      className={
        "font-label text-[9px] px-1.5 py-0.5 rounded border " +
        (isKr
          ? "bg-orange-100 text-orange-800 border-orange-200"
          : "bg-blue-100 text-blue-800 border-blue-200")
      }
    >
      {isKr ? "KR" : "EN"}
    </span>
  );
}

export default function MessageBubble({ role, content, language, time }) {
  const isUser = role === "user";
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className={"flex w-full " + (isUser ? "justify-end" : "justify-start")}
      data-testid={isUser ? "message-bubble-user" : "message-bubble-assistant"}
    >
      <div className={"max-w-[85%] " + (isUser ? "items-end" : "items-start")}>
        <div
          className={
            "rounded-2xl px-4 py-3 text-sm leading-relaxed shadow-sm " +
            (isUser
              ? "bg-[#C25934] text-white rounded-br-md"
              : "bg-white text-[#1F1F1F] rounded-bl-md border border-[#EBE4D3]")
          }
        >
          <p className="whitespace-pre-wrap">{content}</p>
        </div>
        <div
          className={
            "flex items-center gap-2 mt-1 px-1 " + (isUser ? "justify-end" : "justify-start")
          }
        >
          {language ? <LangPill lang={language} /> : null}
          {time ? <span className="text-[10px] text-[#6B7280]">{time}</span> : null}
        </div>
      </div>
    </motion.div>
  );
}
